import React from "react";
import { Link } from 'react-router-dom'
import "../App.css";
import CommentForm from "./CommentForm.jsx";
import helpIcon from "../assets/delete.png";
import likeIcon from "../assets/thumbsup.png";
import ViewIcon from "../assets/View.png"
import "./Post.css"
import commentIcon from "../Component/images/comment.png"
import clockIcon from "../Component/images/clock.png"
import thumbsupIcon from "../Component/images/like.png"
import shareIcon from "../Component/images/share.png"
import reportIcon from "../Component/images/report.png"
import EditStory from "./EditStory";

/* This will render a single post, with all of the options like comments, delete, tags, etc.  In the harness, it's only called from PostingList, but you could
  also have it appear in a popup where they edit a post, etc. */
export default class Post extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      comments: this.props.childrenCount,
      showTags: this.props.post.reactions.length > 0,
      likeStatus: null,
      currentReactionID: null,
      onHomepage: this.props.onHomepage,
      likeCount: 0,
      blocked: false
    };
    this.post = React.createRef();
    this.getLikeCount(this.props.post.id);
    // console.log("POST OBJECT HERE-----> " + JSON.stringify(this.props.post, null, 4));
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_PATH + "/connections?fromUserID=" + sessionStorage.getItem('user') + "&toUserID=" + this.props.post.author.id, {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
    .then(res => res.json())
    .then(
      result => {
        if (result[1] > 0) {
          if (result[0][0].attributes.type === "blocking") {
            this.setState({
              blocked: true
            })
          }
        }else {
          if (this.props.post.attributes.storyPrivacy === "Private" && this.props.post.authorID != sessionStorage.getItem("user")) {
            console.log("POST AUTHOR != LOGGED IN USER HERE _-------------------");
            console.log(this.post.authorID != sessionStorage.getItem("user"));
            this.setState({
              blocked: true
            })
          }
        }
      },
      error => {
        this.setState({
          isLoaded: true,
          error
        });
        console.log("ERROR loading Posts")
      }
    )
  }

  showModal = e => {
    this.setState({
      showModal: !this.state.showModal
    });
  };

  showTags = e => {
    this.setState({
      showTags: !this.state.showTags
    });
  };

  setCommentCount = newcount => {
    this.setState({
      comments: this.state.comments+1
    });
  };

  getCommentCount() {
    return parseInt(this.state.comments);
  }

  async getLikeCount(thisPostID){
    const likeCountResponse = await fetch(process.env.REACT_APP_API_PATH+"/post-reactions?postID="+thisPostID+"&name=like", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
      });

    const apilikeCount = await likeCountResponse.json();

    this.setState({
      likeCount: apilikeCount[1]
    });
  }


  //"like",this.props.post.id
  async userLikedStatus(thisPostID) {

    let user = sessionStorage.getItem("user");
    this.setState({
      likeStatus: null,
      currentReactionID: null
    })

    const reactionsResponse = await fetch(process.env.REACT_APP_API_PATH+"/post-reactions?postID="+thisPostID+"&reactorID="+user+"&name=like", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
      });
    const reactions = await reactionsResponse.json();
    //console.log("Reactions: " + JSON.stringify(reactions[0][0].id,null, 4));
    if(reactions[1] > 0){
      this.setState({
        likeStatus: true,
        currentReactionID: reactions[0][0].id
      })
    } else {
      this.setState({
        likeStatus: false,
      })
    }
    console.log("CURRENT REACTION ID ---->" + this.state.currentReactionID);
  }

  // this is the simplest version of reactions; it's only mananging one reaction, liking a post.  If you unlike the post, 
  // it deletes the reaction.  If you like it, it posts the reaction.  This will almost certainly be made more complex
  // by you, where you will account for multiple different reactions.  Note that in both cases, we reload the post afterwards to
  // show the updated reactions.

  async tagPost(tag, thisPostID){
    await this.userLikedStatus(thisPostID);
    // console.log("likeStatus in tagPost: " + this.state.likeStatus);
     if (this.state.likeStatus){
      //make the api call to post
      fetch(process.env.REACT_APP_API_PATH+"/post-reactions/"+this.state.currentReactionID, {
        method: "DELETE",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+sessionStorage.getItem("token")
        },
      })
        .then(
          result => {
            this.props.loadPosts();
          },
          error => {
            console.log("error!" + error);
          }
        );
     }else{
     //make the api call to post
     fetch(process.env.REACT_APP_API_PATH+"/post-reactions", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      },
      body: JSON.stringify({
        reactorID: sessionStorage.getItem("user"),
        postID: thisPostID,
        name: "like"
      })
      })
      .then(
        result => {
          this.props.loadPosts();
        },
        error => {
          console.log("error!" + error);
        }
      )
     }
    const authorResponse = await fetch(process.env.REACT_APP_API_PATH+"/users/"+this.props.post.authorID, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
    });
    let author = await authorResponse.json();
    console.log("FIRST AUTHOR OBJECT HERE-----> " + JSON.stringify(author, null, 4));
    const authLikes = parseInt(author.attributes.totalLikes);

    if(this.state.likeStatus){
      if(authLikes > 0){
        author.attributes.totalLikes = JSON.stringify(authLikes - 1);
      }
    } else {
      author.attributes.totalLikes = JSON.stringify(authLikes + 1);
    }

    console.log("AUTHOR OBJECT HERE-----> " + JSON.stringify(author, null, 4));

    await fetch(process.env.REACT_APP_API_PATH+"/users/"+this.props.post.authorID, {
      method: "PATCH",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      },
      body: JSON.stringify({
        attributes: {
          username: author.attributes.username,
          pfp: author.attributes.pfp,
          totalLikes: author.attributes.totalLikes
        }
      })
    });

    await this.getLikeCount(thisPostID);
  }


  // this will toggle the CSS classnames that will either show or hide the comment block
  showHideComments() {
    if (this.state.showModal) {
      return "comments show";
    }
    return "comments hide";
  }

  // this will toggle the CSS classnames that will either show or hide the comment block
  showHideTags() {
    if (this.state.showTags) {
      if (this.props.post.reactions.length > 0){
        console.log("Had a reaaction");
        //return "tags show tag-active"
        return "tags hide";
      }
      // return "tags show";
      return "tags hide";
    }
    return "tags hide";
  }


  deletePost(postID) {
    //make the api call to post
    fetch(process.env.REACT_APP_API_PATH+"/posts/"+postID, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
      })
      .then(
        _ => {
          this.props.loadPosts();
          fetch(process.env.REACT_APP_API_PATH+"/users/"+sessionStorage.getItem("user"), {
            method: "GET",
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }
          })
          .then (res => res.json())
          .then (result => {
            fetch(process.env.REACT_APP_API_PATH+"/users/"+sessionStorage.getItem("user"), {
              method: "PATCH",
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+sessionStorage.getItem("token")
              },
              body: JSON.stringify({
                attributes: {
                  pfp: result.attributes.pfp,
                  username: result.attributes.username,
                  totalLikes: result.attributes.totalLikes - this.state.likeCount
                }
              })
            })
          })
        },
        error => {
          console.log("error!" + error);
        }
      );
  }
  deleteComment(postID) {
    //make the api call to post
    fetch(process.env.REACT_APP_API_PATH+"/posts/"+postID, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
      })
      .then(
        result => {
          this.props.loadPosts();
        },
        error => {
          console.log("error!"+error);
        }
      );
  }
  // this is showing both tags hand comments... but used to show only comments.  That's a 
  // frequent cause of names being out of sync with the way things work; do you really want to 
  // risk breaking stuff by changing the name and not knowing everywhere it is called?  
  commentDisplay() {
    console.log("Comment count is " + this.props.post.commentCount);

    if (!this.state.onHomepage) {
      return "";
    }

    //else {
      return (
        <div className="comment-block">
          <div className="tag-block">
            {/*<button value="tag post" onClick={e => this.showTags()}>
            tag post
            </button>*/}
          </div>
          <div name="tagDiv" className={this.showHideTags()}>
          <img
              src={likeIcon}
              className="comment-icon"
              onClick={e => this.tagPost("like",this.props.post.id)}
              alt="Like Post"
            />
          </div>
          <div className="comment-indicator">
          <img
              src={commentIcon}
              className="comment-icon"
              onClick={e => this.showModal()}
              alt="View Comments"
            />
            <div className="comment-indicator-text">
              {this.getCommentCount()}
            </div>
            
          </div>
          <div className={this.showHideComments()}>
            <CommentForm
              onAddComment={this.setCommentCount}
              parent={this.props.post.id}
              commentCount={this.getCommentCount()}
            />
          </div>
        </div>
      );
    //}

  }

  // we only want to expose the delete post functionality if the user is
  // author of the post
  showDelete(){
    if (this.props.post.author.id == sessionStorage.getItem("user")) {
      return(
      <img
        src={helpIcon}
        className="deleteIcon"
        alt="Delete Post"
        title="Delete Post"
        onClick={e => this.deletePost(this.props.post.id)}
      />
    );
    }
    return "";
  }
  showDeleteComment(){
    
    if (this.props.post.author.id == sessionStorage.getItem("user")) {
      return(
      <img
        src={helpIcon}
        className="commentdeleteIcon"
        alt="Delete Post"
        title="Delete Post"
        onClick={e => this.deleteComment(this.props.post.id)}
      />
    );
    
    }
    return "";
  }
  postOrComment(){
    if(!this.props.comment){
      return(
      <div
        key={this.props.post.id}
        className={[this.props.type, "postbody"].join(" ")}
      >
      <div className="postHeader">
      
      <img className="postpfp" alt={!this.state.blocked ? this.props.post.author.attributes.username : "blocked user"} src={!this.state.blocked ? this.props.post.author.attributes.pfp : '/diddy.gif'}></img>
      <Link className="postName" to={!this.state.blocked ? "/user/"+this.props.post.author.id : "/"}>
        {!this.state.blocked ? this.props.post.author.attributes.username : 'Blocked User or Content is private'}
      </Link>

      <img className="postClock" src={clockIcon} alt = "Deadline Representation"></img>
      <div className="postTime">{this.props.post.attributes.votingQuantity} {this.props.post.attributes.votingMeasure}</div>
      {this.props.post.author.id === parseFloat(sessionStorage.getItem("user")) ? <EditStory post={this.props.post} /> : ''}
      {this.showDelete()}
      </div>
        
      { !this.state.onHomepage  && !this.state.blocked ? <div className="postTitle">{this.props.post.attributes.title}</div> : !this.state.blocked ? <Link className="postLink" to={`/post/${this.props.post.id}`}><div className="postTitle">{this.props.post.attributes.title}</div></Link> : <div className="postTitle">This content is blocked or set to private by the author.</div>}

      
      
      { !this.state.onHomepage && !this.state.blocked ? <div className="postText">{this.props.post.content}</div> : !this.state.blocked ? <Link className="postLink" to={`/post/${this.props.post.id}`}><div className="postText">{this.props.post.content}</div></Link> : <div className="postText">This content is from a blocked user or has been set to private.</div>}
      
      {!this.state.blocked ? <div className="postBot">
      {this.commentDisplay()}
        
      <img className="postLike" src={thumbsupIcon} alt = "Post Like Button" onClick={e => this.tagPost("like",this.props.post.id)}></img>
      <div className="liketext">{this.state.likeCount}</div>
        
      <img className="postShare" src={shareIcon} alt = "Post Share Button"></img>
      <div className="sharetext">Share</div>
        
      <img className="postReport" src={reportIcon} alt = "Post Report Button"></img>
      <div className="reporttext">Report</div>
      <Link className = "contributetext" to={`/post/${this.props.post.id}`}>
      <img className = "contributeView" src = {ViewIcon} alt = "View Contributions"></img>
      Contribute!</Link>
      </div> : <div className="postBot">
      <img className="postLike" src={thumbsupIcon} alt = "Post Like Button"></img>
      <div className="liketext">X</div>  
      </div>}

      </div>
      );
    }
    else{
      return(<div>
        <div className = "userAndComment">
          <div>
        <Link to={!this.post.blocked ? "/user/"+this.props.post.author.id : '/'}>
        <img className="commentlistpfp" alt ={!this.post.blocked ? this.props.post.author.attributes.username : 'blocked user'} src={!this.state.blocked ? this.props.post.author.attributes.pfp : '/diddy.gif'}></img>
        <div className="commentName" >
        {!this.post.blocked ? this.props.post.author.attributes.username : "Blocked User"}
      </div></Link> {/*this.showDeleteComment()*/}</div>
      
        <div
        key={this.props.post.id}
        className={[this.props.type, "postbody"].join(" ")}
      >
        <div className="commentText">{!this.post.blocked ? this.props.post.content : "Comment from a blocked user"}</div>
      </div>
      </div>
      <div className="commentFooter">
      <img className="commentReport" src={reportIcon} alt= "Comment Report Button"></img>
      <div className="commentreporttext">Report</div>
      </div>
      </div>
      );
    }
  }
  render() {

    return (
      <div className="thePost">
      {this.postOrComment()}
      </div>
    );
  }
}
